export default (
  state = {
    sharedUsers: [],
    users: [],
    appView: null,
    sharedUser: null,
    metaView: null,
    viewData: null,
    recipientType: null,
    acceptingStates: null,
    senderAttachment: null,
    videoKyc: false,
  },
  action,
) => {
  switch (action.type) {
    case "INIT_SHARED_DOCUMENT_DATA":
      return {
        ...state,
        appView: action.payload.app,
        sharedUser: action.payload.user,
        metaView: action.payload.meta,
        viewData: action.payload.child_view,
        recipientType: action.payload.recipient_type,
        acceptingStates: action.payload.accepting_states,
        senderAttachment: action.payload.sender_attachment,
        videoKyc: action.payload.video_kyc,
      };
    case "REMOVE_SHARED_DOCUMENT":
      return {
        ...state,
        sharedUsers: state.sharedUsers.filter(
          data => data.ShareHash !== action.payload,
        ),
      };

    case "SHARE_DOCUMENT_INIT_DATA": {
      const { users, sharedUsers } = action.payload;
      return {
        ...state,
        users,
        sharedUsers,
      };
    }

    case "DOCUMENT_SHARING_INFORMATION":
      return { ...state, sharedUsers: action.payload };

    case "UPDATE_DOCUMENT_SHARING_INFORMATION": {
      let newData = [];
      if (state.sharedUsers && state.sharedUsers.length > 0) {
        newData = [...action.payload, ...state.sharedUsers];
      } else {
        newData = action.payload;
      }
      return {
        ...state,
        sharedUsers: newData,
      };
    }

    case "UPDATE_DOCUMENT_RECIPIENT":
      return {
        ...state,
        recipientType: action.payload.recipientType,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/DocumentSharedReducer.js